/**
 * Zamiana HTML na czysty tekst — jedno wspólne źródło dla podglądów, skrótów i filtrów.
 *
 * DLACZEGO NIE `innerHTML`: przypisanie HTML do elementu (nawet odłączonego od dokumentu) każe przeglądarce
 * ten HTML SPARSOWAĆ I OŻYWIĆ — `<img src=x onerror=...>` wykonuje kod, a `<img src=...>` pobiera zasób.
 * Treści, na których to działało (opis zadania Kanban, podgląd wiadomości Teams), pochodzą od innych
 * użytkowników, więc był to stored XSS w sesji osoby oglądającej (audyt 2026-08-23, A16-01/A16-02).
 *
 * `DOMParser` buduje dokument ODDZIELONY od bieżącego: skrypty się nie wykonują, `onerror` nie odpala,
 * zasoby nie są pobierane. Wynik jest identyczny jak przy `textContent`, więc dla użytkownika nic się nie zmienia.
 */
export function stripHtml(html) {
    if (!html) return "";
    try {
        return new DOMParser().parseFromString(String(html), "text/html").body.textContent || "";
    } catch {
        return "";
    }
}

/**
 * Skrót tekstowy do podglądów (lista czatów, kafelki) — zamienia HTML na tekst, skleja białe znaki
 * i przycina do `maxLength` znaków z wielokropkiem.
 */
export function stripHtmlPreview(html, maxLength = 100) {
    const text = stripHtml(html).replace(/\s+/g, " ").trim();
    if (!maxLength || text.length <= maxLength) return text;
    return text.slice(0, maxLength) + "…";
}
